<div *ngFor="let r of filteredResults; trackBy: trackByText" class="line">
  <div class="bar" [ngStyle]="{ 'width.%': r.percentage || 0 }" [ngClass]="{selected: r.selected}">&nbsp;</div>
  <div class="label">
    {{ r.text }}: {{ r.percentage || 0 }}%
    <ng-template [ngIf]="r.selected"> + you</ng-template>
  </div>
</div>
